import { Mixins, Component, Watch, Prop } from "vue-property-decorator";
import { CommitableSlidePanel } from "@/components/slide-panel";
import CavCavite from '@/lib/models/cav-cavite';
import ComCommune from '@/lib/models/com-commune';
import BeanCaviteAssociee from '@/lib/models/bean-cavite-associee';
import XInput from '@/components/x-input';
import { getCavitesAssociees } from '@/lib/services';
import { loadingClass } from '@/lib/helpers';

const NOT_FOUND_CAV = {numCavite: "-1"};

type CavChecked = Partial<Pick<CavCavite, "numCavite" | "nomCavite" | "typeCavite"> & {commune: Partial<ComCommune>}>;

@Component
export default class PanelCavAssoc extends Mixins(CommitableSlidePanel) {

  @Prop({type: Boolean}) readonly isNew!: boolean;

  protected cavNumToCheck: string = null;
  protected cavChecked: CavChecked = null;
  protected loading = {
    checkId: 0
  };

  get isCommitable() {
    return this.cavChecked && this.cavChecked !== NOT_FOUND_CAV;
  }

  onClickCommit() {
    if (this.isCommitable) {
      this.commit({data: new BeanCaviteAssociee().inject({
        numCavite: this.cavChecked.numCavite,
        nomCavite: this.cavChecked.nomCavite
      })});
    }
  }

  onClickCancel() {
    this.cancel();
  }

  async onClickCheckId() {
    this.loading.checkId++;
    const [o] = await getCavitesAssociees(this.cavNumToCheck);
    this.cavChecked = o || NOT_FOUND_CAV;
    this.loading.checkId--;
  }

  onInputChange(e) {
    this.cavChecked = null;
  }

  mounted() {
  }

  renderHead() {
    return <span>Associer une cavité par son identifiant</span>
  }

  renderBody() {
    return (
      <div class="basic">
        <div class="field has-addons">
          <div class="control is-expanded">
            <XInput class="input is-small" placeholder="Identifiant de la cavité"
              vModel={this.cavNumToCheck}
              onKeyup={this.onInputChange}/>
          </div>
          <p class="control">
            <button class={`button is-small ${loadingClass(this.loading.checkId)}`} onClick={this.onClickCheckId}>Choisir</button>
          </p>
        </div>
        {this.cavChecked != null && this.cavChecked === NOT_FOUND_CAV && (
          <div class="notification is-danger">
            <small>Aucune cavité n'a été trouvée avec cet identifiant</small>
          </div>
        )}
        {this.cavChecked != null && this.cavChecked !== NOT_FOUND_CAV && (
          <div class="notification is-success">
            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label is-small">Nom</label>
              </div>
              <div class="field-body">
                <p><small>{this.cavChecked.nomCavite}</small></p>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label is-small">Commune</label>
              </div>
              <div class="field-body">
                <p><small>{this.cavChecked.commune.nom}</small></p>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label is-small">Type</label>
              </div>
              <div class="field-body">
                <p><small>{this.cavChecked.typeCavite}</small></p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderFooter() {
    return (
      <div class="columns is-fluid">
        <div class="column is-9"></div>
        <div class="column is-3 is-flex justify-end">
          <button class="button is-small is-fluid" onClick={this.onClickCancel}>Annuler</button>
          <button class="button is-primary is-small is-fluid"
            disabled={this.isCommitable ? undefined : true}
            onClick={this.onClickCommit}>Associer</button>
        </div>
      </div>
    )
  }
  
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-43d9864b/panel-cav-assoc.tsx" });